import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit, AfterViewInit, OnChanges  {

  _totalPages: number = 0;
  _numPage: number = 1;
  _stButton: number = 1;
  _ndButton: number = 2;
  _thButton: number= 3;
  _itemRangeFrom: number = 1;
  _itemRangeTo: number = 0;

  @Input()
  set totalPages(value: number) {
    this._totalPages = value;
  }

  get totalPages(): number {
    return this._totalPages;
  }

  @Input() totalItems: number = 0;
  @Input() pageSize: number = 0;
  @Input() itemsPerPage: number = 0;

  @Output() goToFirstPage: EventEmitter<any> = new EventEmitter();
  @Output() goToPreviousPage: EventEmitter<any> = new EventEmitter();
  @Output() goToNextPage: EventEmitter<any> = new EventEmitter();
  @Output() goToLastPage: EventEmitter<any> = new EventEmitter();
  @Output() goToPage: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    this.changePageRange(1);
    if(this.itemsPerPage != 0) {
      this._itemRangeTo = this.itemsPerPage;
    }
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if(changes.totalPages) {
    //   this.totalPages = changes.totalPages.currentValue;
    // }
    // if (changes.itemsPerPage) {
    //   this.pageSize = changes.itemsPerPage.currentValue;
    // }
    // if (changes.totalItems) {
    //   this.totalItems = changes.totalItems.currentValue;
    // }
    // if (changes.pageSize) {
    //   this.pageSize = changes.pageSize.currentValue;
    // }
    
    // this._numPage = 1;
    // this.changePageRange(1);
    if (changes.totalPages || changes.itemsPerPage || changes.totalItems || changes.pageSize) {
      this.resetComponent();
    }
  }

  resetComponent(): void {
    this._totalPages = this.totalPages;
    this._numPage = 1;
    this._stButton = 1;
    this._ndButton = 2;
    this._thButton = 3;
    this._itemRangeFrom = 1;
    this._itemRangeTo = this.itemsPerPage > 0 ? this.itemsPerPage : 0;
    this.FirstPage();
  }

  changePageRange(numPage: number): void {
    if (numPage == 1) {
      this._itemRangeFrom = 1;
      this._itemRangeTo = +this.pageSize > +this.totalItems ? +this.totalItems : +this.pageSize;
    }
    if (numPage > 1) {
      this._itemRangeFrom = (+this.pageSize * +numPage) - (+this.pageSize - 1);
      this._itemRangeTo = (+this.pageSize * +numPage) > +this.totalItems ? +this.totalItems : (+this.pageSize * +numPage);
    }
  }

  ngAfterViewInit(): void {
    var conjPages = Math.ceil(this._totalPages / 3);
  }

  FirstPage(): void {
    this.goToFirstPage.emit(1);
    this._numPage = 1;
    this._stButton = 1;
    this._ndButton = 2;
    this._thButton = 3;
    this.changePageRange(this._numPage);
  }

  PreviousPage(): void {
    
    if (this._numPage > 1) {
      this._numPage = this._numPage - 1;
      let count = this._totalPages - 1;
      if (this._numPage < count) {
          this._thButton = this._numPage > 3 ? this._numPage : 3;
          this._ndButton = this._numPage > 3 ? this._numPage - 1 : 2;
          this._stButton = this._numPage > 3 ? this._numPage - 2 : 1;
      }
    }
    this.goToPreviousPage.emit(this._numPage);
 
    this.changePageRange(this._numPage);
  }

  NextPage(): void {
    
    this._numPage = this._numPage + 1;
    if (this._numPage <= this._totalPages) {
      if (this._numPage > 3) {
        this._thButton = this._numPage;
        this._ndButton = this._numPage - 1;
        this._stButton = this._numPage - 2;
      }
    }
    this.goToNextPage.emit(this._numPage);
    this.changePageRange(this._numPage);
  }

  LastPage(): void {
    if (+this.totalPages == 1) return;
    this.goToLastPage.emit(this.totalPages);
    this._numPage = this.totalPages;
    this._thButton = this._numPage;
    this._ndButton = this._numPage - 1;
    this._stButton = this._numPage - 2;
    this.changePageRange(this._numPage);
  }
 
  GoToPage(page: number): void {
    this._numPage = page;
    this.goToPage.emit(page);
    this.changePageRange(this._numPage);
  }

}
